<div appValidationContext>
  @for (regime of regimes; track regime) {
    <label
      class="form-check form-control-plaintext"
      for="regime-{{ regime.id }}"
    >
      <input
        id="regime-{{ regime.id }}"
        type="checkbox"
        class="form-check-input"
        appFormControl
        [(ngModel)]="model[regime.id]"
        [disabled]="disabled || (disabledState[regime.id] ?? false)"
        (ngModelChange)="onChange()"
        (blur)="onTouched()"
      />
      <span class="form-check-label">
        {{ regime.name }}
      </span>
    </label>
    @if (regimeTemplate && model[regime.id]) {
      <ng-container
        *ngTemplateOutlet="regimeTemplate; context: { regime: regime }"
      ></ng-container>
    }
  }
  <ng-content></ng-content>
</div>
